import { render, staticRenderFns } from "./ActivityTabEvents.vue?vue&type=template&id=1dca3238&"
import script from "./ActivityTabEvents.vue?vue&type=script&lang=js&"
export * from "./ActivityTabEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports